import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import useAuth from "@/hooks/use-auth";
import { toast } from "@/hooks/use-toast";
import { LogOut } from "lucide-react";
import { useState } from "react";

const Unauthorized = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  
  const handleLogout = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    
    try {
      // Xóa dữ liệu localStorage trước
      localStorage.removeItem('user');
      localStorage.removeItem('authToken');
      localStorage.removeItem('refreshToken');
      
      // Gọi hàm logout để thực hiện API call (nếu có thể)
      await logout().catch(() => {
        // Không làm gì nếu logout API thất bại, đã xóa dữ liệu localStorage
      });
      
      // Thông báo thành công
      toast({
        title: "Đăng xuất thành công",
        description: "Bạn đã đăng xuất khỏi hệ thống.",
      });
    } catch (error) {
      console.error("Lỗi khi đăng xuất:", error);
    } finally {
      // Chuyển hướng về trang đăng nhập với replace để tránh lịch sử back
      window.location.href = "/login";
    }
  };
  
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="mx-auto max-w-md text-center">
        <div className="mb-8 text-red-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="mx-auto h-20 w-20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <path d="M12 8v4" />
            <path d="M12 16h.01" />
          </svg>
        </div>
        <h1 className="mb-2 text-3xl font-bold">Không có quyền truy cập</h1>
        <p className="mb-8 text-muted-foreground">
          Bạn không có quyền truy cập vào trang này. Vui lòng liên hệ quản trị viên nếu bạn cho rằng đây là một lỗi.
        </p>
        <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
          <Button onClick={() => navigate("/")}>
            Về trang chủ
          </Button>
          <Button variant="outline" onClick={() => navigate(-1)}>
            Quay lại
          </Button>
          <Button 
            variant="destructive"
            onClick={handleLogout}
            disabled={isLoggingOut}
            className="flex items-center justify-center"
          >
            <LogOut className="mr-2 h-4 w-4" />
            {isLoggingOut ? "Đang đăng xuất..." : "Đăng xuất"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized; 